import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FloatingContact from './components/FloatingContact';
import Home from './pages/Home';
import MeetSuzi from './pages/MeetSuzi';
import Pricing from './pages/Pricing';
import Booking from './pages/Booking';
import Forms from './pages/Forms';
import NewClientRegistration from './components/forms/NewClientRegistration';
import DogInformationForm from './components/forms/DogInformationForm';
import CatInformationForm from './components/forms/CatInformationForm';
import MedicalAuthorization from './components/forms/MedicalAuthorization';
import VaccinationRecord from './components/forms/VaccinationRecord';
import ServiceAgreement from './components/forms/ServiceAgreement';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/meet-suzi" element={<MeetSuzi />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/forms" element={<Forms />} />
            <Route path="/forms/new-client" element={<NewClientRegistration />} />
            <Route path="/forms/dog-info" element={<DogInformationForm />} />
            <Route path="/forms/cat-info" element={<CatInformationForm />} />
            <Route path="/forms/medical-auth" element={<MedicalAuthorization />} />
            <Route path="/forms/vaccination" element={<VaccinationRecord />} />
            <Route path="/forms/service-agreement" element={<ServiceAgreement />} />
          </Routes>
        </main>
        <Footer />
        <FloatingContact />
      </div>
    </Router>
  );
}

export default App;
